import SampleModal from './SampleModal'
export default SampleModal
